module.exports = __webpack_public_path__ + "img/ann_s.2accfcfd.png";